import { isEqual } from 'lodash-es';
import { DateRange, SearchFilterType } from '../types';
export const makeInitialFilterValue = (filterConfig)=>{
    switch(filterConfig.type){
        case SearchFilterType.MultiSelectFilter:
            return [];
        case SearchFilterType.DateRangeFilter:
            return {
                from: undefined,
                to: undefined
            };
        case SearchFilterType.RadioFilter:
            return filterConfig.defaultOption;
        case SearchFilterType.DateRangeWithPresets:
            return {
                dateRangeOption: DateRange.AllTime,
                dateRange: []
            };
        case SearchFilterType.CustomFilter:
            return filterConfig.initialValue;
    }
};
export const isInitialFilterValue = (filterValue, filterConfig)=>isEqual(filterValue, makeInitialFilterValue(filterConfig));
